import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const VidFlytt = lazy(() => import("@/pages/elavtal/VidFlytt"));

export const Route = createFileRoute("/elavtal/vid-flytt")({
  head: () => seoHead("/elavtal/vid-flytt", { description: "När du flyttar behöver du teckna nytt elavtal till nya adressen. Gör du inget hamnar du automatiskt på ett dyrt anvisat avtal." }),
  component: () => <VidFlytt />,
});
